import memberInfo from '../data/member-info';
import antiForgeryToken from '../data/anti-forgery-token';
import NavigationData from '../data/navigation';
import NavigationFilterData from '../data/navigation-filter';
import MessageBoxUI from '../ui/message-box-ui';
import GoogleTagManager from '../ui/layout/google-tagmanager';
import WindowResize from '../../utils/window-resize';
import TempData from '../data/temp-data';
import Loading from '../ui/loading';
import ModalUI from '../ui/modal-ui';
import ModalTooltipUI from '../ui/modal-tooltip-ui';
import NavigationModal from '../data/navigation-modal';
import Login from '../ui/layout/login';
import SavedSearchMonitorTogglerUI from '../ui/saved-search-monitor-toggler-ui';
import WindowLoad from '../../utils/window-load';
import WindowScroll from '../../utils/window-scroll';
import PreventDefault from '../../utils/prevent-default';
import SignupReferralPathCookieCreator from '../ui/layout/signup-referral-path-cookie-creator';
import * as LoginSignupEvents from '../ui/layout/login-signup-events';

const attachFlightComponents = (initData) => {
    Login.attachTo(document);

    NavigationFilterData.attachTo(document);
    // this service is needed even when pushstate is disabled
    NavigationData.attachTo(document, {
        version: initData.version
    });
    GoogleTagManager.attachTo(document);
    PreventDefault.attachTo(document.body);
    ModalUI.attachTo(document.body);
    ModalTooltipUI.attachTo(document.body);
    MessageBoxUI.attachTo('.message-box-wrapper');
    WindowResize.attachTo(document);

    TempData.attachTo('#temp-data');
    Loading.attachTo(document);
    NavigationModal.attachTo(document);
    SavedSearchMonitorTogglerUI.attachTo(document.body);
    WindowLoad.attachTo(document);
    WindowScroll.attachTo(document);

    SignupReferralPathCookieCreator.attachTo('[data-reg-user-link]');

    LoginSignupEvents.TrackLoginSuccessComponent.attachTo(
        '[data-track-login-success]'
    );
    LoginSignupEvents.TrackConnectSuccessComponent.attachTo(
        '[data-track-connect-success]'
    );
    LoginSignupEvents.TrackLoginFailureComponent.attachTo(
        '[data-track-login-failure]'
    );
    LoginSignupEvents.TrackConnectFailureComponent.attachTo(
        '[data-track-connect-failure]'
    );
};

export default (initData, skipAttachFlight = false) => {
    memberInfo.set(initData);
    antiForgeryToken.set(initData);
    if (!skipAttachFlight) {
        attachFlightComponents(initData);
    }
};
